import { styled, Box } from '@mui/material';
import { COLORS } from '../../../../../utils/colors';
import { marked } from 'marked';

export const useEditableBlocksStyles = () => {
  return {
    responseStyle: {
      backgroundColor: '#ffbd83',
      padding: '0.2rem',
      borderRadius: '0.3rem',
      transition: 'background-color 0.3s ease',
    },
    cursor: {
      cursor: 'pointer',
      overflow: 'hidden',
    },
    none: {
      overflow: 'hidden',
    },
    hiddenDiv: {
      display: 'flex',
      border: '2px dashed #ccc',
      borderRadius: '10px',
      padding: '20px',
      textAlign: 'center',
      margin: '1rem',
      color: '#888',
      width: '10rem',
      height: '11rem',
      justifyContent: 'center',
    },
    images: {
      width: '10rem',
      height: '11rem',
      margin: '2rem',
      borderRadius: '1rem',
    },
    imageOverlay: {
      width: '100%',
      height: '100%',
      overflow: 'hidden',
      zIndex: '1000',
      pointerEvents: 'auto',
      display: 'flex',
      alignItems: 'bottom',
    },
    imageOverlay2: {
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'flex-end',
      width: '100%',
      height: '100%',
      marginBottom: '0.5rem',
    },
    gridItem: {
      md: 3,
      xs: 6,
      sm: 4,
      backgroundColor: 'white !important',
      margin: '1rem',
    },
    actionArea: {
      display: 'flex',
      borderRadius: '.625rem',
      height: '11rem',
      width: '10rem',
    },
    overFlow: {
      overflowY: 'auto' as 'auto',
    },
    sketchCanvas: {
      zIndex: 0,
    },
    editorCanvasWrapper: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    isImageLoading: {},
    delete: {
      padding: '0.1rem',
      backgroundColor: 'white',
      borderRadius: '1rem',
      color: COLORS.BLACK,
    },
    edit: {
      padding: '0.1rem',
      marginRight: '0.5rem',
      marginLeft: '1rem',
      backgroundColor: 'white',
      borderRadius: '1rem',
      color: COLORS.BLACK,
    },
    report: {
      boxShadow: 'none',
      mb: '1rem',
      mt: '1rem',
      borderRadius: '1rem',
      backgroundImage:
        'linear-gradient(264deg, rgb(255, 110, 0) 50%, rgb(255, 120, 30) 65%, rgb(255, 158, 84) 100%)',
      textTransform: 'capitalize',
      color: '#fff',
      '&.Mui-disabled': {
        color: '#fff',
      },
    },
    context: {
      marginTop: '0.5rem',
      display: 'block',
      textAlign: 'right',
      right: '5rem',
      top: '16rem',
    },
    documentRef: {
      boxShadow: '0px 3px 6px rgba(0, 0, 0, 0.3)',
      margin: '1.5rem .5rem',
      minHeight: 'calc(100vh - 10rem)',
      overflow: 'hidden',
      padding: '0.8rem',
      display: 'block',
    },
    dropImage: {
      display: 'flex',
      height: '100%',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '1.5rem',
      fontWeight: 'bold',
    },
    titleInput: {
      margin: '1rem 1rem .5rem 1rem',
      fontSize: '2em',
      fontWeight: 'bold',
      width: '90%',
      border: 'none',
      borderBottom: '2px solid #ccc',
      outline: 'none',
    },
    select: {
      minWidth: '10rem',
      padding: '0.25rem',
      borderRadius: '0.5rem',
      '& .MuiSelect-select': {
        padding: '.25rem !important',
      },
    },
    selectLabel: {
      fontSize: '1rem',
      backgroundColor: 'white',
      px: '.5rem',
    },
    formItem: {
      display: 'flex',
      alignItems: 'center',
      paddingLeft: '2rem',
    },
    formCheckbox: {
      //color: '#5bbfc2',
      height: '1.5rem',
      width: '1.5rem',
      marginRight: '0.5rem',
      '&.Mui-checked': {
        color: '#5bbfc2',
      },
    },
    formInputContainer: {
      marginLeft: '1rem',
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      mr: '.5rem',
    },
    formInput: {
      '& .MuiInputBase-root': {
        fontSize: '0.875rem',
        '& fieldset': {
          borderWidth: '.125rem',
        },
        '&.Mui-focused fieldset': {
          borderWidth: '.125rem',
        },
      },
      '& input': {
        fontWeight: '500',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      },
    },
    tooltip: {
      popper: {
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: [0, 8],
            },
          },
        ],
      },
      tooltip: {
        sx: {
          backgroundColor: 'white',
          color: '#666',
          border: '.0625rem solid #ccc',
          fontSize: '.875rem',
        },
      },
      arrow: {
        sx: {
          color: 'white',
          '&::before': {
            border: '.0625rem solid #ccc',
          },
        },
      },
    },
  };
};

export const useChecklistStyles = () => {
  return {
    checklist: {
      margin: '1rem',
    },
    modal: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      bgcolor: 'background.paper',
      boxShadow: 24,
      p: 4,
      borderRadius: 2,
      maxWidth: 400,
    },
    checklistItem: {
      display: 'flex',
      alignItems: 'center',
      paddingLeft: '1rem',
    },
    checkBox: {
      height: '1.5rem',
      width: '1.5rem',
      marginRight: '0.5rem',
      color: COLORS.MEDIUM_GRAY,
    },
    checklistItemText: {
      margin: 0,
    },
    checklistItemTextContainer: {
      display: 'flex',
      alignItems: 'center',
    },
    iconButton: {
      padding: '.25rem',
      backgroundColor: '#ffdab3',
      display: 'inline-flex',
      alignItems: 'center',
      marginLeft: '0.5rem',
      verticalAlign: 'middle',
    },
  };
};

export const StyledImageOverlay = styled(Box)({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '8.75rem',
  height: '8.75rem',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  color: 'white',
  background: 'rgba(26, 38, 96, 0.4)',
  opacity: 0,
  transition: 'opacity 0.3s ease',
  borderRadius: '.625rem',
  cursor: 'pointer',
  ':hover': {
    opacity: 1,
  },
});

export const StyledResults = styled(Box)`
  &.ql-container.ql-snow,
  .ql-container.ql-snow {
    border: none !important;
    height: auto;
    min-height: 6vh;
    overflow-y: hidden;
    font-size: 0.93rem;
  }

  .ql-editor {
    // background: #fff5eb;
    height: auto;
    padding: 0;
    padding-top: 0;
    padding-bottom: 0;
    line-height: 1.72;
    overflow-y: hidden;

    h1,
    h2,
    h3,
    div,
    ul,
    li,
    p {
      font-family: 'Montserrat', sans-serif !important;
      margin-top: 0.2em;
      margin-bottom: 0.2em;
    }

    p,
    ul,
    li {
      line-height: 1.4;
      margin-top: 0.25rem;
      margin-bottom: 0.25rem;
    }

    ul {
      padding-left: 1.2rem;
      margin-left: 0;
    }

    li {
      margin-bottom: 0.2rem;
    }

    ol {
      margin: 0;
      margin-top: 1em;
      margin-bottom: 1em;
      list-style-position: inside;
    }

    pre.ql-syntax {
      background-color: unset;
      color: #000;
      overflow: visible;
      line-height: 1.7;
    }

    pre {
      margin: 0;
      padding: 0;
    }

    *[data-read-only='true'],
    h1[data-read-only='true'] {
      pointer-events: none;
      /* user-select: none; */
    }
  }

  .ql-toolbar.ql-snow {
    margin-top: 1rem;
    margin-right: 3.5rem;
    white-space: nowrap;
  }

  .ql-toolbar {
    position: absolute;
    top: 0;
    background-color: white;
    display: none;
  }

  .ql-snow .ql-tooltip {
    left: 1.2rem !important;
    border-radius: 3rem;
    border: 2px solid #ebebeb;
  }

  .ql-snow .ql-tooltip[data-mode='link']::before {
    content: 'Link:';
  }

  .ql-snow .ql-tooltip.ql-editing a.ql-action::after {
    color: #ff6e00;
  }
`;
